/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { environment } from '../environments/environment';
import {AngularFireModule} from 'angularfire2';
import {AngularFirestoreModule} from 'angularfire2/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import {UsersService} from './service/users.service';
import {ScootersService} from './service/scooters.service'
import {BatteriesService} from './service/batteries.service'
import { MapsService } from './service/maps.service';
import {DashboardpaymentsService} from './service/scootersearnings.service';
import {ChargingpointsService} from './service/chargingpoints.service';
import {SwapstationsService} from './service/swapstations.service';
import {AssetsdashboardService} from './service/assetsdashboard.service';
import {TotalearningsService} from './service/totalearnings.service';
import {UserspaymentsService} from './service/userspayments.service';
import {IssuesService} from './service/issues.service';
import { AuthService } from './service/auth.service';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { AngularFireAuth } from '@angular/fire/auth';
import {AngularFireStorageModule} from 'angularfire2/storage'
import {AgmCoreModule} from '@agm/core';
import {AuthGuardService} from './service/auth-guard.service';
import {DataFetchService} from './service/data-fetch.service';
import { FormsModule }   from '@angular/forms';



@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyBVdVj9KOdfkvXnCJlz3khYITkuYqMeHFc',
    }),
    CoreModule.forRoot(),
    FormsModule,
  ],
  providers: [UsersService, TotalearningsService, ScootersService, MapsService, BatteriesService, DashboardpaymentsService, ChargingpointsService, SwapstationsService, AssetsdashboardService, UserspaymentsService, IssuesService, AuthService, AuthGuardService, DataFetchService ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
